import React, { useEffect, useState } from "react";
import { mergeSortHelper } from "../SortingAlgorithms/MergeSort";
import { InsertionSortHelper } from "../SortingAlgorithms/InsertionSort";
import "./SortingVisualizer.css";
import { SelectionSortHelper } from "../SortingAlgorithms/SelectionSort";

// Change this value for the speed of the animations.
const ANIMATION_SPEED_MS = 5;

// Change this value for the number of bars (value) in the array.
const NUMBER_OF_ARRAY_BARS = 310;

// This is the main color of the array bars.
const PRIMARY_COLOR = "pink";

// This is the color of array bars that are being compared throughout the animations.
const SECONDARY_COLOR = "black";
const SortingVisualizer = () => {
  const [array, setArray] = useState([5, 2, 3, 1]);
  useEffect(() => {
    resetArray();
  }, []);

  const resetArray = () => {
    const array = [];
    for (let i = 0; i < 310; i++) {
      array.push(randomNumberInIntervals(5, 730));
    }
    setArray(array);
  };
  const randomNumberInIntervals = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  const mergeSort = () => {
    const animations = mergeSortHelper(array);
    console.log(animations);
    for (let i = 0; i < animations.length; i++) {
      const arrayBars = document.getElementsByClassName("array-bars");
      const isColorChange = i % 3 !== 2;
      if (isColorChange) {
        const [barOneIdx, barTwoIdx] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;
        setTimeout(() => {
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
        }, ANIMATION_SPEED_MS);
      } else {
        setTimeout(() => {
          const [barOneIdx, newHeight] = animations[i];
          console.log(barOneIdx, newHeight);
          const barOneStyle = arrayBars[barOneIdx].style;
          barOneStyle.height = `${newHeight}px`;
        }, i * ANIMATION_SPEED_MS);
      }
    }
  };

  const insertionSort = () => {
    InsertionSortHelper(array);
  };
  const selectionSort = () => {
    SelectionSortHelper(array);
  };
  return (
    <div className="container">
      {array.map((num, idx) => (
        <div
          key={idx}
          style={{
            height: `${num}px`,
            backgroundColor: PRIMARY_COLOR,
          }}
          className="array-bars"
        ></div>
      ))}
      <div style={{ xbackgroundColor: "yellow" }}>
        <button className="btn btn-outline-danger lg mr-1" onClick={resetArray}>
          Generate Numbers
        </button>
      </div>
      <div style={{ marginBottom: "10px", backgroundColor: "yellow" }}>
        <button className="btn btn-outline-primary lg mr-1" onClick={mergeSort}>
          MERGE SORT
        </button>
        <button
          className="btn btn-outline-primary lg mr-1"
          onClick={insertionSort}
        >
          INSERTION SORT
        </button>
        <button
          className="btn btn-outline-primary lg mr-1"
          onClick={selectionSort}
        >
          SELECTION SORT
        </button>
      </div>
    </div>
  );
};

export default SortingVisualizer;
